import { Constant } from '@configs/index';
import { yupResolver } from '@hookform/resolvers/yup';
import { InputDate, InputText, Radio } from '@molecules/Forms';
import { OpenFormType } from '@organisms/GenesisEs/Forms/OpenFormType';
import { Storage } from '@states/Storage';
import { Button, Form } from 'react-bootstrap';
import { SubmitHandler, useForm } from 'react-hook-form';
import styled from 'styled-components';
import * as yup from 'yup';
import { Tooltip } from '../Utils';

type Props = {
    submitHandler: any;
};

const schema = yup.object().shape({
    // contactId: yup.string().matches(/^(|[0-9]+)$/, '数字を入力してください'),
    powerCustomerLocationNumber: yup.string().matches(/^(|[0-9]{22})$/, '数字22桁で入力してください'),
});
const clearValues: OpenFormType = Constant.SEARCH_FORM_DATA.DEFAULT;
const descriptions = Constant.TOOLTIP_DESCRIPTIONS;

const OpenForm = (props: Props) => {
    const defaultValues: OpenFormType = Storage.get(Storage.keys.GENESISES_OPENLIST);
    const { register, handleSubmit, reset, clearErrors, setValue, getValues, formState: { errors } } = useForm<OpenFormType>({ defaultValues, resolver: yupResolver(schema) });
    
    const onClear = () => {
        clearErrors();
        reset();
        setValue('contactId', clearValues.contactId);
        setValue('powerCustomerLocationNumber', clearValues.powerCustomerLocationNumber);
        setValue('relitRequestDate', clearValues.relitRequestDate);
        setValue('relitDesiredDate', clearValues.relitDesiredDate);
        setValue('supplyStartDate', clearValues.supplyStartDate);
        setValue('acceptStatus', clearValues.acceptStatus);
        setValue('systemClass', clearValues.systemClass);
        // setValue('responseStatus', clearValues.responseStatus); 
    };
    const onSubmit: SubmitHandler<OpenFormType> = (data: OpenFormType) => {
        data.timestamp = new Date().getTime();
        props.submitHandler(data);
        Storage.set(Storage.keys.GENESISES_OPENLIST, data);
    };

    return (
        <FormWithStyled>
            <TableWithStyled className='searchTable'>
                <TBodyWithStyled>
                    <RowWithStyled>  
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>契約ID</LabelWithStyled>
                                <Tooltip description={descriptions.CONTACT_ID} idKey='ID' />
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputText
                                register = {register}
                                controlId='contactId'
                                width='small'
                                error={errors.contactId}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled>  
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>供給地点特定番号</LabelWithStyled>
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputText
                                register={register}
                                controlId='powerCustomerLocationNumber'
                                error={errors.powerCustomerLocationNumber}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled> 
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>再点依頼日</LabelWithStyled>
                                <Tooltip description={descriptions.REQUEST_DATE} idKey='REQUEST_DATE' />
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputDate
                                register={register}
                                controlId='relitRequestDate'
                                setValue={setValue}
                                getValues={getValues}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled> 
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>再点希望日</LabelWithStyled>
                                <Tooltip description={descriptions.PREFERRED_DATE} idKey='PREFERRED_DATE' />
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputDate
                                register={register}
                                controlId='relitDesiredDate'
                                setValue={setValue}
                                getValues={getValues}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled> 
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>供給開始日</LabelWithStyled>
                                <Tooltip description={descriptions.OPEN_DATE} idKey='OPEN_DATE' />
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputDate
                                register={register}
                                controlId='supplyStartDate'
                                setValue={setValue}
                                getValues={getValues}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled> 
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>受付工程</LabelWithStyled>
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <Form.Group controlId="acceptStatus">
                                {Constant.ACCEPT_STATUS_FOR_FORM.map((item) => (
                                    <span key={`acceptStatus-${item.value}`}>
                                        <Form.Check
                                            inline
                                            value={item.value}
                                            type='checkbox'
                                            label={item.label}
                                            id={`acceptStatus-${item.value}`}
                                            {...register('acceptStatus')}
                                        />
                                        {item.label === '送信不要' ? <FormCheckToolTipWithStyled><Tooltip description={descriptions.ACCEPT_STATUS_NNTR} idKey='acceptStatus_NNTR' placement='bottom' /></FormCheckToolTipWithStyled> : ''}
                                    </span>
                                ))}
                            </Form.Group>
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled> 
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>システム</LabelWithStyled>
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <Radio
                                register={register}
                                controlId='systemClass'
                                data={Constant.SYSTEM_CLASS}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    {/* <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>警告対応</LabelWithStyled>
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <Radio
                                register={register}
                                controlId='responseStatus'
                                data={Constant.RESPONSE_STATUS}
                            />
                        </BodyWithStyled>
                    </RowWithStyled> */}

                </TBodyWithStyled>
            </TableWithStyled>

            <ButtonsWithStyled>
                <Button variant='secondary' size='sm' onClick={onClear}>　クリア　</Button>{' '}
                <Button variant='primary' size='sm' onClick={handleSubmit(onSubmit)}>　検　索　</Button>
            </ButtonsWithStyled>

        </FormWithStyled>
    )
}


const FormWithStyled = styled.form`
    margin: 5px 5px 10px;
`
const TableWithStyled = styled.table`
`
const TBodyWithStyled = styled.tbody`
`
const RowWithStyled = styled.tr`
`
const HeadWithStyled = styled.th`
`
const BodyWithStyled = styled.td`
`
const LabelWithStyled = styled.span`
`
const FormCheckToolTipWithStyled = styled.span`
    position: relative;
    right: 16px;
`
const ButtonsWithStyled = styled.div`
    & button + button {
        margin-left:10px;
    }
`

export default OpenForm;